import { getApiBaseUrl } from '@utils/apiBaseUrl'

export async function trackLandingPageView(heroVariant: number): Promise<void> {
  const url = `${getApiBaseUrl()}/public/landing-analytics/view`
  try {
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ heroVariant }),
      keepalive: true,
    })
  } catch {
    // best-effort analytics
  }
}
